import { getDefaultClient } from '@dynamic-labs-sdk/client';
import { getWalletProviderFromWalletAccount } from '@dynamic-labs-sdk/client/core';
import type { Transaction, VersionedTransaction } from '@solana/web3.js';

import type { SolanaWalletAccount } from '../SolanaWalletAccount.types';
import { NotSolanaProviderError } from '../errors/NotSolanaProviderError';
import { isSolanaWalletProvider } from '../isSolanaWalletProvider';

type SignTransactionParams = {
  transaction: Transaction | VersionedTransaction;
  walletAccount: SolanaWalletAccount;
};

/**
 * Signs a Solana transaction
 * @param params.transaction - The transaction to sign
 * @param params.walletAccount - The wallet account to sign the transaction with
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An object containing the signed transaction
 */
export const signTransaction = async (
  { walletAccount, transaction }: SignTransactionParams,
  client = getDefaultClient()
): Promise<{ signedTransaction: Transaction | VersionedTransaction }> => {
  const provider = getWalletProviderFromWalletAccount(
    {
      walletAccount,
    },
    client
  );

  if (!isSolanaWalletProvider(provider)) {
    throw new NotSolanaProviderError({ providerKey: provider.key });
  }

  return provider.signTransaction({ transaction, walletAccount });
};
